import axios from 'axios';
import authHeader from './auth-header';
import CommonServices from './common.service';

const API_URL = CommonServices.getApiUrl() + 'household';

class HouseholdService {

  get() {
    return axios.get(API_URL, { headers: authHeader() });
  }

  rename(name) {
    return axios.put(API_URL, { name }, { headers: authHeader() });
  }

  addMember(emailOrUsername, household_role) {
    return axios.post(API_URL + '/members', { emailOrUsername, household_role },
      { headers: authHeader() });
  }

  changeRole(userId, household_role) {
    return axios.put(API_URL + '/members/' + userId, { household_role },
      { headers: authHeader() });
  }

  removeMember(userId) {
    return axios.delete(API_URL + '/members/' + userId, { headers: authHeader() });
  }
}

export default new HouseholdService();
